import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('workflow', '');

const workflowActions = {
  listar: { method: 'GET', url: `${basePath}cadastro?tamanhoPagina={size}&numeroPagina={page}` },
  inativar: { method: 'PUT', url: `${basePath}cadastro/ativacao/{id}/false` },
  ativar: { method: 'PUT', url: `${basePath}cadastro/ativacao/{id}/true` },
  atualizar: { method: 'PUT', url: `${basePath}cadastro` },
  gravar: { method: 'POST', url: `${basePath}cadastro` },
  buscarCondicionais: { method: 'GET', url: `${basePath}cadastro/condicional/{id}` },
  buscarTipos: { method: 'GET', url: `${basePath}cadastro/tipos` },
  buscaUnica: { method: 'GET', url: `${basePath}cadastro/{id}` },
  buscarDescricoes: { method: 'GET', url: `${basePath}cadastro/passo/descricao{/idTipo}` },
  reenviarEmailAprovacao: { method: 'POST', url: `${basePath}execucao/passos/{idPasso}/entidade/{entidade}/reenviar-email-aprovacao` },
};

export default (resource) => resource(`${basePath}`, {}, workflowActions);
